import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import WalletBox from "../partials/WalletBox";
import { withRouter, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from "@ashvin27/react-datatable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import $ from "jquery";
import classnames from "classnames";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import SidebarWallet from "./SidebarWallet";
import socketIOClient from "socket.io-client";
import Moment from "moment";
import * as myConstList from "../../BaseUrl";
import ReactGA from "react-ga";
const baseUrl = myConstList.baseUrl;
const capitalizeFunc = myConstList.capitalize;
const jwtToken = localStorage.getItem("jwtToken");
const configToken = {
  headers: {
    Authorization: "Bearer " + `${localStorage.getItem("jwtToken")}`,
  },
};
class Wallet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      records: [],
      bonus: "",
      balance: "",
      winningamount: "",
      thirdPhaseConfig:"",
      currentSocketId:"",
    };

    this.columns = [
      {
        key: "_id",
        text: "Id",
        className: "id",
        align: "left",
        sortable: true,
        cell: (row, index) => index + 1,
      },
      {
        key: "amount",
        text: "Amount",
        className: "Amount",
        align: "left",
        sortable: true,
        cell: (record) => {
          return (
            <Fragment>
              {record.winningPrize !== undefined
                ? record.coinsName !== null ?record.amount + "   " + record.coinsName:record.amount + "   " + record.winningPrize
                : record.amount}
            </Fragment>
          );
        },
      },
      {
        key: "contestName",
        text: "Contest Name",
        className: "Contest Name",
        sortable: true,
        align: "left",
        cell: (record) => {
          return (
            <Fragment>
              {/* {<Link to={"/trading-contest/"+record.contest_id._id}> {capitalizeFunc(record.contest_id.contestName)}</Link>} */}
              {
                <a href={"/trading-contest/" + record.contest_id}>
                  {capitalizeFunc(record.contestName)}
                </a>
              }
            </Fragment>
          );
        },
      },
      {
        key: "transType",
        text: "Tx Type",
        className: "transType",
        align: "left",
        sortable: true,
      },
      {
        key: "date",
        text: "Date",
        className: "date",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>{Moment(record.transactionsDate).format("lll")}</Fragment>;
        },
      },
    ];

    this.config = {
      page_size: 10,
      length_menu: [10, 20, 50],
      filename: "Fund Request List",
      no_data_text: "No user found!",
      button: {
        print: true,
        csv: true,
      },
      language: {
        length_menu: "Show _MENU_ result per page",
        filter: "Filter in records...",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        pagination: {
          first: "First",
          previous: "Previous",
          next: "Next",
          last: "Last",
        },
      },
      show_length_menu: true,
      show_filter: true,
      show_pagination: true,
      show_info: true,
    };

    this.state = {
      records: [],
    };

    this.getData = this.getData5.bind(this);
  }
  editRecord(record) {
    this.setState({ reject: record.reject, approve: record.approve });
  }
  componentWillReceiveProps(nextProps) {
    // this.getData5();
  }
  componentDidMount() {
    const socket = socketIOClient(baseUrl, {query:"jwtToken=" +jwtToken });
    var collectThis = this;
    socket.on("connect", () => {
      collectThis.setState({ currentSocketId: socket.id });
      socket.emit("config3rdphase");
      socket.on("3rdPhaseConfig", function (apiRespData) {
        // console.log("apiRespData==",apiRespData);      
        if (socket.id == collectThis.state.currentSocketId) {
          collectThis.setState({ thirdPhaseConfig: apiRespData.data[0].mainfunctionality });
          // console.log("collectThis====",apiRespData.data[0].mainfunctionality);
        }
      });
    });    
    this.getData5();
  }
  getData5() {
    const { user } = this.props.auth;
    axios
      .post(baseUrl + "api/getTransactionWithdral", {}, configToken)
      .then((res) => {
        this.setState({ records: res.data.data });
      })
      .catch();
    /* axios
        .post(baseUrl+"api/profile-data",{},configToken)
        .then(res => {
          if(res.data.data.videoStatus!=="verify" && this.props.urlPath!=false){
             this.setState({modalIsOpen: true}); 
          }

          this.setState({ bonus:res.data.data.bonus,balance:res.data.data.balance.toFixed(2),videoStatus:res.data.data.videoStatus,winningamount:res.data.data.winningamount })})
        .catch() */
  }
  
  pageChange(pageData) {
    // console.log("OnPageChange", pageData);
  }

  render() {
    const { errors } = this.state;

    return (
      <>
        <Navbar urlPath={true} symbol={false} thirdPhaseConfig={this.state.thirdPhaseConfig}/>
        <Sidebar />
        <div class="container">
          <div class=" padding_d in_page">
            <h5 class=" mb-3">Winning History</h5>
            {/* <WalletBox/> */}

            <div class="row">
              <div className="col-md-12">
                <div className="tab-content">
                  <div className="white_box ">
                    {/* <h5 className=" mb-3 mb-md-4">Winning History
                        </h5> */}
                    <div className="ccrool_table">
                      <ReactDatatable
                        config={this.config}
                        records={this.state.records}
                        columns={this.columns}
                        onPageChange={this.pageChange.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <ToastContainer />
      </>
    );
  }
}

Wallet.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,

  errors: state.errors,
});

export default connect(mapStateToProps)(withRouter(Wallet));
